// extracted by mini-css-extract-plugin
module.exports = {"root":"NoTaskList__root___X7Aov","description":"NoTaskList__description___Rf8oU"};